import axios from "axios"

interface DraftData {
  activeIndex: number
  activeTab: string
  formData: any
  email?: string
  announcementType: string
}

export const saveDraft = async (
  data: any,
): Promise<{
  success: boolean
  message: string
  draftId?: string
}> => {
  try {
    // Récupérer le token d'authentification
    const token = localStorage.getItem("token")

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/drafts/create`,
      {
        ...data,
        user_id: localStorage.getItem("userId"),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return {
      success: true,
      message: "Brouillon sauvegardé. Un email a été envoyé.",
      draftId: response.data.id,
    }
  } catch (error: any) {
    console.log(error?.response?.data?.data)
    console.error("Erreur lors de la sauvegarde du brouillon:", error)
    return { success: false, message: "Erreur lors de la sauvegarde du brouillon." }
  }
}

export const getDraft = async (draftId: string): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    // Récupérer le token d'authentification
    const token = localStorage.getItem("token")

    const response = await axios.get(`${process.env.REACT_APP_API_URL}/drafts/${draftId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    // Vérifier si les données contiennent un type d'annonce
    if (response.data && !response.data.announcementType && response.data.announcement_type) {
      response.data.announcementType = response.data.announcement_type
    }

    return { success: true, data: response.data }
  } catch (error: any) {
    console.error("Erreur lors de la récupération du brouillon:", error)

    // Message d'erreur plus spécifique
    let message = "Impossible de récupérer le brouillon."
    if (error.response) {
      if (error.response.status === 403) {
        message = "Vous n'êtes pas autorisé à accéder à ce brouillon. Veuillez vous reconnecter."
        // Rediriger vers la page de connexion si nécessaire
        // window.location.href = "/login"
      } else if (error.response.status === 404) {
        message = "Ce brouillon n'existe pas ou a été supprimé."
      }
    }

    return { success: false, message }
  }
}

export const getDrafts = async (): Promise<{
  success: boolean
  data?: { [key: string]: string }[]
  message?: string
}> => {
  try {
    // Récupérer le token d'authentification
    const token = localStorage.getItem("token")

    const response = await axios.get(`${process.env.REACT_APP_API_URL}/drafts/user/${localStorage.getItem("userId")}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    // Normaliser les données pour s'assurer que announcementType est toujours présent
    const normalizedData = response.data.map((draft: any) => {
      if (!draft.announcementType && draft.announcement_type) {
        draft.announcementType = draft.announcement_type
      }
      return draft
    })

    return { success: true, data: normalizedData }
  } catch (error: any) {
    console.error("Erreur lors de la récupération des brouillons:", error)

    let message = "Impossible de récupérer les brouillons."
    if (error.response && error.response.status === 403) {
      message = "Vous n'êtes pas autorisé à accéder à vos brouillons. Veuillez vous reconnecter."
      // Rediriger vers la page de connexion si nécessaire
      // window.location.href = "/login"
    }

    return { success: false, message }
  }
}

export const deleteDraft = async (
  draftId: string,
): Promise<{
  success: boolean
  message: string
}> => {
  try {
    // Récupérer le token d'authentification
    const token = localStorage.getItem("token")

    await axios.delete(`${process.env.REACT_APP_API_URL}/drafts/${draftId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return { 
      success: true, 
      message: " "
     }
  } catch (error: any) {
    console.error("Erreur lors de la suppression du brouillon:", error)

    let message = "Impossible de supprimer le brouillon."
    if (error.response && error.response.status === 403) {
      message = "Vous n'êtes pas autorisé à supprimer ce brouillon."
    }

    return { success: false, message }
  }
}
